import { Map, List } from 'immutable';
import { LoadingStatusEnum } from '../../../../../lib/enums';
import { actionTypes } from '../../../../controller';

const {
	START_FETCH_CONVERSATION_REPLIES,
	FETCH_CONVERSATION_REPLIES_SUCCESS,
	FETCH_CONVERSATION_REPLIES_FAILED,

	START_FETCH_NEXT_CONVERSATION_REPLIES,
	FETCH_NEXT_CONVERSATION_REPLIES_SUCCESS,
	FETCH_NEXT_CONVERSATION_REPLIES_FAILED,

	START_CREATE_TEXT_CONVERSATION_REPLY,
	CREATE_TEXT_CONVERSATION_REPLY_SUCCESS,
	CREATE_TEXT_CONVERSATION_REPLY_FAILED,

	START_CREATE_FILE_CONVERSATION_REPLY,
	CREATE_FILE_CONVERSATION_REPLY_SUCCESS,
	CREATE_FILE_CONVERSATION_REPLY_FAILED,

	START_CREATE_FORM_FILE_CONVERSATION_REPLY,
	CREATE_FORM_FILE_CONVERSATION_REPLY_SUCCESS,
	CREATE_FORM_FILE_CONVERSATION_REPLY_FAILED,

	START_SELECT_CONVERSATION_TAG,
	SELECT_CONVERSATION_TAG_SUCCESS,
	SELECT_CONVERSATION_TAG_FAILED,

	START_SELECT_CONVERSATION_QA_OPTION,
	SELECT_CONVERSATION_QA_OPTION_SUCCESS,
	SELECT_CONVERSATION_QA_OPTION_FAILED,

	START_CREATE_CONVERSATION_FORM_REPLY,
	CREATE_CONVERSATION_FORM_REPLY_SUCCESS,
	CREATE_CONVERSATION_FORM_REPLY_FAILED,

	START_SEND_TYPEING_CONVERSATION_REPLY,
	SEND_TYPEING_CONVERSATION_REPLY_SUCCESS,
	APPEND_CONVERSATION_REPLIES,

	RECEIVE_CONVERSATION_REPLY,
	RECEIVE_UPDATED_CONVERSATION_REPLY,

	RESET_CONVERSATION_REPLY,

	START_RESET_CONVERSATION_SMART_REPLY,
	RESET_CONVERSATION_SMART_REPLY_SUCCESS,

	START_CONTACT_CS_CONVERSATION,
	CONTACT_CS_CONVERSATION_SUCCESS,
	CONTACT_CS_CONVERSATION_FAILED,

	START_CREATE_CONVERSATION_QA_FORM_REPLY,
	CREATE_CONVERSATION_QA_FORM_REPLY_SUCCESS,
	CREATE_CONVERSATION_QA_FORM_REPLY_FAILED,

	START_CREATE_QA_FORM_FILE_CONVERSATION_REPLY,
	CREATE_QA_FORM_FILE_CONVERSATION_REPLY_SUCCESS,
	CREATE_QA_FORM_FILE_CONVERSATION_REPLY_FAILED,

	START_CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY,
	CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_SUCCESS,
	CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_FAILED,

	START_CREATE_QUICK_FORM_CONVERSATION_REPLY,
	CREATE_QUICK_FORM_CONVERSATION_REPLY_SUCCESS,
	CREATE_QUICK_FORM_CONVERSATION_REPLY_FAILED,
} = actionTypes;
const {
	NONE,
	LOADING,
	SUCCESS,
	FAILED,
} = LoadingStatusEnum;
const initialState = Map({
	data: List(),
	formFiles: Map(),
	hasNext: false,

	loadingStatus: NONE,
	loadingStatusMessage: '',

	fetchNextConversationRepliesLoadingStatus: NONE,
	fetchNextConversationRepliesLoadingStatusMessage: '',

	createTextConversationReplyLoadingStatus: NONE,
	createTextConversationReplyLoadingStatusMessage: '',

	createFileConversationReplyLoadingStatus: NONE,
	createFileConversationReplyLoadingStatusMessage: '',

	selectConversationReplyTagLoadingStatus: NONE,
	selectConversationReplyTagLoadingStatusMessage: '',

	selectConversationReplyQAOptionLoadingStatus: NONE,
	selectConversationReplyQAOptionLoadingStatusMessage: '',

	createConversationFormReplyLoadingStatus: NONE,
	createConversationFormReplyLoadingStatusMessage: '',

	sentTypingConversationReplyLoadingStatus: NONE,

	resetSmartReplyLoadingStatus: NONE,
	resetSmartReplyLoadingStatusMessage: '',

	contactCSLoadingStatus: NONE,
	contactCSLoadingStatusMessage: '',

	createConversationQAFormReplyLoadingStatus: NONE,
	createConversationQAFormReplyLoadingStatusMessage: '',

	createQAFormFileConversationReplyLoadingStatus: NONE,
	createQAFormFileConversationReplyLoadingStatusMessage: '',

	createConversationQAChargeFormReplyLoadingStatus: NONE,
	createConversationQAChargeFormReplyLoadingStatusMessage: '',

	createQuickFormLoadingStatus: NONE,
	createQuickFormLoadingStatusMessage: '',
});

export default function conversationReply(state = initialState, action) {
	switch (action.type) {
		case START_FETCH_CONVERSATION_REPLIES:
			return state
				.set('loadingStatus', LOADING);

		case FETCH_CONVERSATION_REPLIES_SUCCESS:
			return state
				.set('hasNext', action.hasNext)
				// Socket payload 不得就地改寫(logger 延後序列化契約)
				.set('data', List([...action.conversationReplies].reverse()))
				.set('loadingStatus', SUCCESS);

		case FETCH_CONVERSATION_REPLIES_FAILED:
			return state
				.set('loadingStatus', FAILED)
				.set('loadingStatusMessage', action.errorMessage);

		case START_FETCH_NEXT_CONVERSATION_REPLIES:
			return state
				.set('fetchNextConversationRepliesLoadingStatus', LOADING);

		case FETCH_NEXT_CONVERSATION_REPLIES_SUCCESS:
			return state
				.set('hasNext', action.hasNext)
				.update('data', conversationReplies => conversationReplies
					.reverse()
					.concat(action.conversationReplies)
					.reverse(),
				)
				.set('fetchNextConversationRepliesLoadingStatus', SUCCESS);

		case FETCH_NEXT_CONVERSATION_REPLIES_FAILED:
			return state
				.set('fetchNextConversationRepliesLoadingStatus', FAILED)
				.set('fetchNextConversationRepliesLoadingStatusMessage', action.errorMessage);

		case START_CREATE_TEXT_CONVERSATION_REPLY:
			return state
				.set('createTextConversationReplyLoadingStatus', LOADING);

		case CREATE_TEXT_CONVERSATION_REPLY_SUCCESS:
			return state
				.updateIn(['data'], replies => List([...replies, action.conversationReply]))
				.set('createTextConversationReplyLoadingStatus', SUCCESS);

		case CREATE_TEXT_CONVERSATION_REPLY_FAILED:
			return state
				.set('createTextConversationReplyLoadingStatus', FAILED)
				.set('createTextConversationReplyLoadingStatusMessage', action.errorMessage);

		case START_CREATE_FILE_CONVERSATION_REPLY:
			return state
				.set('createFileConversationReplyLoadingStatus', LOADING);

		case CREATE_FILE_CONVERSATION_REPLY_SUCCESS:
			return state
				.set('createFileConversationReplyLoadingStatus', SUCCESS);

		case CREATE_FILE_CONVERSATION_REPLY_FAILED:
			return state
				.set('createFileConversationReplyLoadingStatus', FAILED)
				.set('createFileConversationReplyLoadingStatusMessage', action.errorMessage);

		case START_CREATE_FORM_FILE_CONVERSATION_REPLY:
			return state
				.set('createFileConversationReplyLoadingStatus', LOADING);
		case CREATE_FORM_FILE_CONVERSATION_REPLY_SUCCESS:
			return state
				.set('createFileConversationReplyLoadingStatus', SUCCESS);
		case CREATE_FORM_FILE_CONVERSATION_REPLY_FAILED:
			return state
				.set('createFileConversationReplyLoadingStatus', FAILED)
				.set('createFileConversationReplyLoadingStatusMessage', action.errorMessage);

		case START_SELECT_CONVERSATION_TAG:
			return state
				.set('selectConversationReplyTagLoadingStatus', LOADING);

		case SELECT_CONVERSATION_TAG_SUCCESS:
			return state
				.set('selectConversationReplyTagLoadingStatus', SUCCESS);

		case SELECT_CONVERSATION_TAG_FAILED:
			return state
				.set('selectConversationReplyTagLoadingStatus', FAILED)
				.set('selectConversationReplyTagLoadingStatusMessage', action.errorMessage);

		case START_SELECT_CONVERSATION_QA_OPTION:
			return state
				.set('selectConversationReplyQAOptionLoadingStatus', LOADING);

		case SELECT_CONVERSATION_QA_OPTION_SUCCESS:
			return state
				.set('selectConversationReplyQAOptionLoadingStatus', SUCCESS);

		case SELECT_CONVERSATION_QA_OPTION_FAILED:
			return state
				.set('selectConversationReplyQAOptionLoadingStatus', FAILED)
				.set('selectConversationReplyQAOptionLoadingStatusMessage', action.errorMessage);

		case START_CREATE_CONVERSATION_FORM_REPLY:
			return state
				.set('createConversationFormReplyLoadingStatus', LOADING);

		case CREATE_CONVERSATION_FORM_REPLY_SUCCESS:
			return state
				.updateIn(['data'], conversationReplies => {
					const convertedConversationReplies = conversationReplies.toArray();

					convertedConversationReplies.pop();

					return List(convertedConversationReplies.concat(action.conversationReplies));
				})
				.set('createConversationFormReplyLoadingStatus', SUCCESS);

		case CREATE_CONVERSATION_FORM_REPLY_FAILED:
			return state
				.set('createConversationFormReplyLoadingStatus', FAILED)
				.set('createConversationFormReplyLoadingStatusMessage', action.errorMessage);

		case START_SEND_TYPEING_CONVERSATION_REPLY:
			return state
				.set('ConversationReplyLoadingStatus', LOADING);

		case SEND_TYPEING_CONVERSATION_REPLY_SUCCESS:
			return state
				.set('ConversationReplyLoadingStatus', SUCCESS);

		case APPEND_CONVERSATION_REPLIES:
			return state
				.updateIn(['data'], conversationReplies => conversationReplies.concat(action.conversationReplies));

		case RECEIVE_CONVERSATION_REPLY:
			return state.update('data', replies => replies.concat(action.conversationReplies));

		case RECEIVE_UPDATED_CONVERSATION_REPLY: {
			const { updatedConversationReplies } = action;
			const revokedQuoteReplyInConversationReplies = replies => {
				const newReplies = replies.map(reply => {
					const { id, quoteReply } = reply;
					let newReply = reply;

					for (const updatedReply of updatedConversationReplies) {
						const { id: updatedReplyId } = updatedReply;

						if (updatedReplyId === id) {
							newReply = updatedReply;
						}

						if (updatedReplyId === quoteReply?.id) {
							// Socket payload 不得就地改寫(logger 延後序列化契約)
							newReply = { ...newReply, quoteReply: updatedReply };
						}
					}

					return newReply;
				});

				return newReplies;
			};

			return state.update('data', revokedQuoteReplyInConversationReplies);
		}

		case RESET_CONVERSATION_REPLY:
			return initialState;

		case START_RESET_CONVERSATION_SMART_REPLY:
			return state
				.set('resetSmartReplyLoadingStatus', LOADING);

		case RESET_CONVERSATION_SMART_REPLY_SUCCESS:
			return state
				.set('resetSmartReplyLoadingStatus', SUCCESS);

		case START_CONTACT_CS_CONVERSATION:
			return state
				.set('contactCSLoadingStatus', LOADING);

		case CONTACT_CS_CONVERSATION_SUCCESS:
			return state
				.set('contactCSLoadingStatus', SUCCESS);

		case CONTACT_CS_CONVERSATION_FAILED:
			return state
				.set('contactCSLoadingStatus', FAILED);

		case START_CREATE_CONVERSATION_QA_FORM_REPLY:
			return state
				.set('createConversationQAFormReplyLoadingStatus', LOADING);

		case CREATE_CONVERSATION_QA_FORM_REPLY_SUCCESS:
			return state
				.updateIn(['data'], conversationReplies => {
					const convertedConversationReplies = conversationReplies.toArray();

					convertedConversationReplies.pop();

					return List(convertedConversationReplies.concat(action.conversationReplies));
				})
				.set('createConversationQAFormReplyLoadingStatus', SUCCESS);

		case CREATE_CONVERSATION_QA_FORM_REPLY_FAILED:
			return state
				.set('createConversationQAFormReplyLoadingStatus', FAILED)
				.set('createConversationQAFormReplyLoadingStatusMessage', action.errorMessage);

		case START_CREATE_QA_FORM_FILE_CONVERSATION_REPLY:
			return state
				.set('createQAFormFileConversationReplyLoadingStatus', LOADING);

		case CREATE_QA_FORM_FILE_CONVERSATION_REPLY_SUCCESS:
			return state
				.updateIn(['formFiles', action.conversationReplyId, action.title], () => action.formFile)
				.set('createQAFormFileConversationReplyLoadingStatus', LOADING);

		case CREATE_QA_FORM_FILE_CONVERSATION_REPLY_FAILED:
			return state
				.set('createQAFormFileConversationReplyLoadingStatus', FAILED)
				.set('createQAFormFileConversationReplyLoadingStatusMessage', action.errorMessage);

		case START_CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY:
			return state
				.set('createConversationQAChargeFormReplyLoadingStatus', LOADING);

		case CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_SUCCESS:
			return state
				.updateIn(['data'], conversationReplies => {
					const convertedConversationReplies = conversationReplies.toArray();

					convertedConversationReplies.pop();

					return List(convertedConversationReplies.concat(action.conversationReplies));
				})
				.set('createConversationQAChargeFormReplyLoadingStatus', SUCCESS);

		case CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_FAILED:
			return state
				.set('createConversationQAChargeFormReplyLoadingStatus', FAILED)
				.set('createConversationQAChargeFormReplyLoadingStatusMessage', action.errorMessage);

		case START_CREATE_QUICK_FORM_CONVERSATION_REPLY:
			return state
				.set('createQuickFormLoadingStatus', LOADING);

		case CREATE_QUICK_FORM_CONVERSATION_REPLY_SUCCESS:
			return state
				.set('createQuickFormLoadingStatus', SUCCESS);

		case CREATE_QUICK_FORM_CONVERSATION_REPLY_FAILED:
			return state
				.set('createQuickFormLoadingStatus', FAILED)
				.set('createQuickFormLoadingStatusMessage', action.errorMessage);

		default:
			return state;
	}
}
